// extracted by mini-css-extract-plugin
export default {"container":"EventDetailsQuoteDetail_container__fYSmH","label":"EventDetailsQuoteDetail_label__57KO3","value":"EventDetailsQuoteDetail_value__C97b1"};